import { useEffect } from 'react'
import { createRootRoute, Outlet, useRouter } from '@tanstack/react-router'
import { ReloginDialog } from '@/components/ReloginDialog'
import { useAnalytics } from '@/hooks/use-analytics'
import { GlobalAnnouncementModal } from '@/components/GlobalAnnouncementModal'

/** capture_pageview é false em src/lib/posthog.ts — SPA precisa disparar $pageview manualmente por rota. */
export function PageviewTracker() {
  const router = useRouter()
  const { capture } = useAnalytics()

  useEffect(() => {
    return router.subscribe('onResolved', () => {
      capture('$pageview')
    })
  }, [router, capture])

  return null
}

export const Route = createRootRoute({
  component: () => (
    <>
      <PageviewTracker />
      <Outlet />
      <ReloginDialog />
      <GlobalAnnouncementModal />
    </>
  ),
})
